<template>
  <div class="piebox">
    <elevators-status-chart :pie="true" :groupId="groupId" v-bind:elevators="elevators"></elevators-status-chart>
    <h4 align="center" v-if="name">
      <b-link v-if="groupId" :to="{ name: 'group', params: { id: groupId } }">{{ name }}</b-link>
      <span v-else>{{ name }}</span>
    </h4>
  </div>
</template>

<script>
import api from './api.js'
import auth from './auth.js'

import ElevatorsStatusChart from './ElevatorsStatusChartSimple.vue'

export default {
  name: 'elevators-status-small',
  props: [
    'id',
    'groupId',
    'name',
    'elevators',
    'pie',
  ],
  components: {
    'elevators-status-chart': ElevatorsStatusChart,
  },
  data() {
    return {
    }
  },
}
</script>

<style>
h4 {
  margin-top: 1em;
  min-height: 3em;
}
.piebox {
  margin-top: 1em;
  margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/ElevatorsStatusSmall.vue